// src/RegistrationIcon.tsx
import { jsx } from "react/jsx-runtime";
var RegistrationIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.154 5.009c.103-.226.248-.432.278-.684.214-1.799-2.24-2.278-2.786-.722-.193.543-.064.846.166 1.321.017.034.06.026 0 .073C3.44 5.527.808 8.514.727 11.932h14.551c-.086-3.406-2.735-6.462-6.12-6.927zM8 4.898a.794.794 0 0 1-.794-.795A.794.794 0 0 1 8 3.308a.794.794 0 0 1 .795.795.794.794 0 0 1-.795.794m5.495 6.384c-.308-.051-.359-.658-.457-.94-.47-1.329-1.556-2.5-2.846-3.064-.171-.077-.804-.256-.88-.346-.146-.167-.078-.466.145-.517.299-.065 1.21.38 1.505.546 1.325.744 2.367 2.047 2.782 3.513.078.265.257.889-.247.807m-2.329-6.166c.325-.261-.077-.513-.166-.744-.261-.684.671-1.602.439-2.466-.06-.226-.273-.534-.542-.492a.36.36 0 0 0-.265.265c-.034.197.145.278.188.427.111.406-.56 1.436-.509 2.12.026.346.415 1.248.859.893zm1.731-1.137c.32-.295-.15-.551-.206-.812-.171-.837.966-1.88.308-2.683-.119-.146-.226-.231-.427-.188-.197.043-.24.282-.184.449.026.081.128.132.154.23.103.444-.551 1.393-.517 2.055.017.355.436 1.346.876.945zm2.868 8.598L.256 12.568c-.188.078-.325.257-.226.458.162.329.649.141.935.218l1.538 1.226 10.932.012c.572-.35 1.06-.833 1.594-1.239.273-.077.722.098.906-.175.142-.205.022-.389-.171-.492",
        fill: "#fff"
      }
    )
  }
);
var RegistrationIcon_default = RegistrationIcon;

export {
  RegistrationIcon_default
};
